<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>

    <v-dialog v-model="dialog.konfirmasi" persistent width="450">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Konfirmasi</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.konfirmasi = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5 text-center mt-2">
          <span class="font-weight-bold title">Simpan data?</span>
          <v-card-subtitle class="pt-0">
            <span class="body-2"
              >Pastikan data yang akan disimpan sudah sesuai.</span
            >
          </v-card-subtitle>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.form"
            @click="dialog.konfirmasi = false"
          >
            Batal
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save"
          >
            Ya, simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoadingComponent v-if="process.loading"></LoadingComponent>

    <v-row class="mt-3 px-3" v-if="!process.loading">
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <ValidationObserver ref="observer">
                  <v-form>
                    <div>
                      <v-row>
                        <v-col cols="12">
                          <div class="color-first title font-weight-bold mt-2">
                            Data diri
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="mt-5">
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <ValidationProvider
                            name="Nama lengkap"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              outlined
                              label="Nama lengkap"
                              color="#0299B7"
                              v-model="form.data_diri.nama"
                              :error-messages="errors"
                              require
                            >
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <ValidationProvider
                            name="Email aktif"
                            rules="required|email"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              outlined
                              label="Email aktif"
                              color="#0299B7"
                              v-model="form.data_diri.email"
                              :error-messages="errors"
                              require
                            >
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <ValidationProvider
                            name="Nomor induk kepegawaian"
                            rules="required|min:4|max:32"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              outlined
                              label="Nomor induk kepegawaian"
                              color="#0299B7"
                              v-model="form.data_diri.nip"
                              :error-messages="errors"
                              require
                            >
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <ValidationProvider
                            name="No. whatsapp aktif"
                            rules="min:10|max:14"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              outlined
                              label="No. whatsapp aktif (Optional)"
                              color="#0299B7"
                              v-model="form.data_diri.whatsapp"
                              :error-messages="errors"
                            >
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                          <div>
                            <span>Status</span>
                          </div>
                          <v-switch
                            class="mt-0 switch"
                            v-model="switch_status"
                            color="#0499b7"
                            value="true"
                            :label="
                              switch_status === 'true' ? 'Aktif' : 'Tidak aktif'
                            "
                            hide-details
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </div>

                    <v-card-actions
                      class="mt-10 justify-center"
                      style="border-top: 1px solid #bac0c6"
                    >
                      <div class="mt-5">
                        <v-btn
                          large
                          width="120"
                          elevation="0"
                          :disabled="process.form"
                          class="text-capitalize mr-2"
                          @click="
                            reset();
                            toHome();
                          "
                        >
                          Batal
                        </v-btn>
                        <v-btn
                          large
                          width="120"
                          color="#0299B7"
                          elevation="0"
                          :disabled="process.form"
                          @click="cekForm()"
                          class="white--text text-capitalize"
                        >
                          Simpan
                        </v-btn>
                      </div>
                    </v-card-actions>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get, post, put } from "@/service/Axios";
import { TokenService } from "@/service/Storage.Service";
import Snackbar from "@/components/Snackbar.vue";
import LoadingComponent from "@/components/Loading.vue";

export default {
  data() {
    return {
      dialog: {
        konfirmasi: false
      },
      form: {
        data_diri: {
          nama: "",
          email: "",
          nip: "",
          whatsapp: "",
          uuid: ""
        }
      },
      process: {
        run: false,
        form: false,
        loading: false
      },
      isEdit: false,
      switch_status: "true",
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },
  components: {
    Snackbar,
    LoadingComponent
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      const uuid = TokenService.getUuid();
      const detail = JSON.parse(localStorage.getItem("lecturer_detail"));
      this.isEdit = this.$route.path === "/dosen/edit";
      if (detail) {
        // prefer stored detail (set by list page) to avoid overwriting
        // fields like email when backend detail is missing
        this.isEdit = true;
        this.setForm(detail);
      } else if (uuid) {
        this.isEdit = true;
        this.getDetail(uuid);
      } else if (this.isEdit && !detail) {
        this.toHome();
      }
    },

    async getDetail(uuid) {
      try {
        this.process.loading = true;
        this.process.run = true;
        const params = { uuid };
        const response = await get("lecturer", { params });
        if (response.status === 200) {
          const data = response.data.data || [];
          const detail = data[0] || {};
          if (detail.uuid || detail.namaDosen || detail.nama) {
            this.setForm({
              nama: detail.namaDosen || detail.nama || "",
              email: detail.email || "",
              nip:
                detail.nipDosen ||
                detail.noInduk ||
                detail.noIndukKepegawaian ||
                "",
              whatsapp: detail.noWhatsapp || detail.noHp || "",
              flag_aktif: detail.flagAktif,
              uuid: detail.uuid || uuid
            });
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.process.loading = false;
        this.process.run = false;
      }
    },

    setForm(detail) {
      this.form.data_diri = {
        nama: detail.nama || "",
        email: detail.email || "",
        nip: detail.nip || "",
        whatsapp: detail.whatsapp === "-" ? "" : detail.whatsapp || "",
        uuid: detail.uuid || ""
      };
      // determine flag value from possible keys and types
      let flag = 1;
      if (detail.flag_aktif !== undefined && detail.flag_aktif !== null) {
        flag = Number(detail.flag_aktif);
      } else if (detail.flagAktif !== undefined && detail.flagAktif !== null) {
        flag = Number(detail.flagAktif);
      }
      this.switch_status = flag === 1 ? "true" : null;
    },

    async cekForm() {
      const isValid = await this.$refs.observer.validate();
      this.dialog.konfirmasi = isValid;
    },

    async save() {
      this.process.form = true;
      try {
        const params = {
          uuid: this.form.data_diri.uuid,
          nama: this.form.data_diri.nama,
          email: this.form.data_diri.email,
          nik: this.form.data_diri.nip,
          no_telepon: this.form.data_diri.whatsapp,
          flag_aktif: this.switch_status !== null ? 1 : 0
        };
        const response = this.isEdit
          ? await put("lecturer", { data: params })
          : await post("lecturer", { data: params });

        if (response.status === 200 || response.status === 201) {
          this.dialog.konfirmasi = false;
          this.text = response.data.info || "Data dosen berhasil disimpan";
          this.snackbar = true;
          this.toHome();
          this.reset();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.process.form = false;
      }
    },

    reset() {
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
      this.form = {
        data_diri: {
          nama: "",
          email: "",
          nip: "",
          whatsapp: "",
          uuid: ""
        }
      };
      this.switch_status = "true";
      TokenService.removeUUID(TokenService.getUuid());
      localStorage.removeItem("lecturer_detail");
    },

    toHome() {
      this.$router.push("/dosen");
    }
  }
};
</script>

<style scoped>
.switch .v-label {
  font-size: 14px;
}
</style>
